module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-ekanban-348e352ee710872fb7add028c7c304ae.png";